var _defs, _rect, _path, _polyline, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 127.82 114.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#63ffe5;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:8px;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 576.95,
    cy: 57.41,
    r: 132.46,
    gradientTransform: "translate(-224.57 2.74) scale(0.5 0.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58ead7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#55e3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4dcfc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3fafb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#389fa8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 3.5,
    width: 120.82,
    height: 107.82,
    rx: 30.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.21,7a26.64,26.64,0,0,1,26.61,26.6V81.22a26.64,26.64,0,0,1-26.61,26.6H33.6A26.63,26.63,0,0,1,7,81.22V33.6A26.63,26.63,0,0,1,33.6,7H94.21m0-7H33.6A33.6,33.6,0,0,0,0,33.6V81.22a33.6,33.6,0,0,0,33.6,33.6H94.21a33.6,33.6,0,0,0,33.61-33.6V33.6A33.6,33.6,0,0,0,94.21,0Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "65.94 30.9 65.94 57.41 65.94 83.92"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.14,
    y1: 57.41,
    x2: 89.73,
    y2: 57.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOn);
export default __webpack_public_path__ + "static/media/Plus On.6ad87796cb0a899857d4f188af907575.svg";
export { ForwardRef as ReactComponent };